import Logger from '../../../common/logger';
import * as ChatActions from '../../components/views/chat/actions';
import BotMockAPI from './BotMockAPI';
import { BOT } from './types';
import { APIMode } from '../types';
import { Helpers } from './helpers';
import { fetchTimeout } from '../../../common/fetch';

export default class BotDriver {
    constructor(store) {
        this.store = store;
        this.ApiTimeout = Helpers.getApiTimeout(this.store);
        this.ApiErrorMessage = Helpers.getApiErrorMessage(this.store);
    }

    setApiUrl(botName) {
        this.ApiUrl = Helpers.getApiUrl(this.store) + (botName ? '/' + botName + '/' : '');
        Logger.log(`[BOT] ApiUrl=${this.ApiUrl}`);
    }

    sendRequest({ request, callbacks }) {
        Logger.log(`[BOT] sendRequest: ${JSON.stringify(request)}`);

        this.getResponseFromAPI({
            request,
            callbacks
        });

        // this.getResponseFromMockAPI({
        //     request,
        //     callbacks
        // });
    }

    getResponseFromAPI({ request, callbacks }) {
        if (!this.ApiUrl) {
            this.ApiUrl = Helpers.getApiUrl(this.store);
        }

        const addErrorMessage = () => {
            const state = this.store.getState();
            if (state && state.chat && state.chat.mode === APIMode.BOT) {
                this.store.dispatch(
                    ChatActions.addChatEvent({
                        message: this.ApiErrorMessage,
                        id: -1,
                        from: 'system',
                        isRead: false,
                        timestamp: new Date().valueOf(),
                        localtimestamp: new Date().valueOf(),
                        chatEnded: true,
                        type: ChatActions.MESSAGE_TYPE.SESSION_END
                    })
                );
            }
        };

        const TIMEOUT = 'TIMEOUT';
        Logger.log('[BOT] ApiTimeout: ' + this.ApiTimeout);
        fetchTimeout(
            this.ApiUrl,
            {
                method: 'POST',
                headers: {
                    Accept: '*/*',
                    'Content-Type': 'text/plain; charset=UTF-8'
                },
                body: JSON.stringify(request)
            },
            this.ApiTimeout * 1000,
            TIMEOUT
        )
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    addErrorMessage();
                    return {
                        statusCode: 2,
                        chatEnded: true,
                        errors: [
                            {
                                code: response.status,
                                advice: response.statusText
                            }
                        ],
                        _widgetInternal: true
                    };
                }
            })
            .then((response) => {
                // statusCode = 0 - ok, 1 - error but retry, 2 - error final
                if (response.error) {
                    Logger.error('[BOT] response: ' + JSON.stringify(response));
                } else {
                    Logger.log('[BOT] response: ' + JSON.stringify(response));
                }

                if (callbacks.success) {
                    callbacks.success(response);
                }
            })
            .catch((error) => {
                if (
                    error === TIMEOUT ||
                    error.message.indexOf('Unexpected token < in JSON at position 0') > -1
                ) {
                    addErrorMessage();
                }
                Logger.error(
                    '[BOT] error: ' + JSON.stringify(error && error.stack ? error.stack : error)
                );
                if (callbacks.error) {
                    callbacks.error(error);
                }
            });
    }

    getResponseFromMockAPI({ request, callbacks }) {
        BotMockAPI.getResponse({ request, callbacks });
    }

    urlEncodeParams(params, parent_property = undefined) {
        const formBody = [];
        for (const property in params) {
            if (Object.prototype.hasOwnProperty.call(params, property)) {
                const encodedKey = parent_property
                    ? encodeURIComponent(parent_property) + '[' + encodeURIComponent(property) + ']'
                    : encodeURIComponent(property);
                const value = params[property];
                if (Array.isArray(value)) {
                    const subparams = this.urlEncodeParams(value, property);
                    formBody.push(subparams);
                } else {
                    const encodedValue = encodeURIComponent(value);
                    formBody.push(encodedKey + '=' + encodedValue);
                }
            }
        }
        return formBody.join('&');
    }

    processMessages({ response, callbacks }) {
        Logger.log(`[BOT] processResponse: ${JSON.stringify(response)}`);
        let isTransfer = false;

        if (response && response.messages) {
            const messageValue = [];
            response.messages.forEach((message) => {
                switch (message.type) {
                    case BOT.MESSAGE_TYPE.CONTROLS.TEXT:
                    case BOT.MESSAGE_TYPE.CONTROLS.BUTTONS:
                    case BOT.MESSAGE_TYPE.CONTROLS.INPUTS:
                    case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTON_INPUTS:
                    case BOT.MESSAGE_TYPE.CONTROLS.RADIOBUTTONS:
                        messageValue.push(JSON.stringify(message).replace('&', '%26'));
                        break;
                    case BOT.MESSAGE_TYPE.COMMANDS.REFRESH:
                        callbacks.refresh(message.value ? message.value : null);
                        break;
                    case BOT.MESSAGE_TYPE.COMMANDS.TRANSFER:
                        isTransfer = true;
                        callbacks.transfer();
                        break;
                    case BOT.MESSAGE_TYPE.COMMANDS.CHANGE:
                        this.setApiUrl(message.value);
                        break;
                    case BOT.MESSAGE_TYPE.COMMANDS.FINISH:
                        Logger.log('BotDriver.processMessages: finish');
                        callbacks.endSession(true, 'BOT');
                        break;
                    default:
                        break;
                }
            }, this);

            let messageId = response.index;
            if (isTransfer) {
                let sessionString = sessionStorage.getItem('oplwidget.chat');
                if (sessionString === 'null') {
                    sessionString = null;
                }
                if (sessionString) {
                    const session = JSON.parse(sessionString);
                    messageId = session.lastChatPosition ? session.lastChatPosition : messageId;
                }
            }

            if (messageValue.length > 0) {
                this.addBotMessageToWidget({
                    message: messageValue.join('&'),
                    id: messageId,
                    from: 'agent'
                });
            }
        }
    }

    addBotMessageToWidget({ message, username = 'Bot', id, from }) {
        this.store.dispatch(
            ChatActions.addChatEvent({
                message: message,
                username: username,
                timestamp: new Date().valueOf(),
                localtimestamp: new Date().valueOf(),
                id: id,
                from: from,
                type: ChatActions.MESSAGE_TYPE.BOT_MESSAGE
            })
        );
    }

    getTransferMessage(messages) {
        let isTransfer = false;
        let message = '';
        messages.forEach((m) => {
            if (m.type === BOT.MESSAGE_TYPE.COMMANDS.TRANSFER) {
                isTransfer = true;
            } else if (m.type === BOT.MESSAGE_TYPE.CONTROLS.TEXT) {
                message = m.value;
            }
        });
        return isTransfer ? message : '';
    }
}
